/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Model_Row1_ModelInputs */

const en_mk_model_row1_model = /** @type {(inputs: Mk_Model_Row1_ModelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fast model (Terra)`)
};

const id_mk_model_row1_model = /** @type {(inputs: Mk_Model_Row1_ModelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Model cepat (Terra)`)
};

/**
* | output |
* | --- |
* | "Fast model (Terra)" |
*
* @param {Mk_Model_Row1_ModelInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_model_row1_model = /** @type {((inputs?: Mk_Model_Row1_ModelInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Model_Row1_ModelInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_model_row1_model(inputs)
	return en_mk_model_row1_model(inputs)
});